__turbopack_context__.v({
  "listingRate": "listing-rate-module-scss-module__r7bo4a__listingRate",
  "listingRate__isDetailed": "listing-rate-module-scss-module__r7bo4a__listingRate__isDetailed",
  "listingRate_value": "listing-rate-module-scss-module__r7bo4a__listingRate_value",
});
